<template>
    <div class="com-part5">
		<title1 type="1" title="算力租赁统计" style="margin-top: 30px" />
        <div class="p-content flex align-center justify-content">
            <!-- <div
                v-for="(item, i) in list"
                :key="'list' + i"
                class="item flex justify-center align-center">
                <div class="item-l flexs" :style="{'background': item.color}"></div>
                <div class="item-c flexs" :style="{'color': item.color}">{{ item.label }}</div>
                <div class="item-r flex1">
                    <dv-digital-flop style="height: 30px; width: 100%" :config="dvDigitalFlopConfig(item)" />
                </div>
            </div> -->
            <div class="flex flex-direction align-items list" v-for="(item,index) in list" :key="'list'+ index">
                <div class="num">{{Number(item.number).toFixed(0)}}<span class="unit">{{item.unit}}</span></div>
                <div class="name">{{item.label}}</div>
                <img class="img" :src="require(`@/assets/images/computility/overview-GPU.png`)" alt="">
            </div>
        </div>
    </div>
</template>

<script>
import title1 from '@/views/exposition/components/title1'
import { dataInterface } from "@/api/dataInterfaceApi"
export default {
    components: {
        title1
    },
    data() {
        return {
            list: [
                {
                    number: '',
                    label: '当前GPU卡',
                    unit:''
                },
                {
                    number: '',
                    label: '租用中GPU卡',
                    unit:''
                },
                {
                    number: '',
                    label: '当天出租率',
                    unit:'%'
                },
            ],
        }
    },
	mounted() {
        this.selectStationAlarmList()
    },
	methods: {
        // 字体动态
        dvDigitalFlopConfig(item = {}) {
            let counts = parseFloat(item.value || 0)
            let config = {
                number: [parseFloat(counts)],
                textAlign: item.textAlign || 'center',
                style: {
                    fill: item.color || '#fff',
                    fontSize: item.fontSize || 32,
					fontFamily: 'DS-Digital-Bold'
                }
            }
            console.log('==config==', config)
            return config
        },
        // 副标题切换
        subTitleChange(i) {
            this.subTitleAt = i
        },
        selectStationAlarmList(data = {}) {
			let _this = this;
			let params = {
                "enCode": "computingpower-right-slzltj",
            }
			dataInterface
				.dataFaceApi(params)
				.then((res) => {
					if (!res) return;
                    console.log('算力租赁统计',res)
                    this.list[0].number = res[0].now_gpu_total || '-'
                    this.list[1].number = res[0].gpu_total || '-'
                    this.list[2].number = res[0].now_rate || '-'
				})  
				.catch((err) => {
					console.log(err);
				});
		},
    }
}
</script>

<style lang="scss" scoped>
@import '../comm.scss';


.com-part5 {
    width: 100%;
    height: 475px;
    .sub-title {
        font-size: $FontSize20;
        padding-top: 20px;
        height: 50px;
        > div {
            padding-right: 20px;
            > p {
                text-shadow: 0px 0px 9px #03B9BD;
                padding: 0 10px;
                position: relative;
                cursor: pointer;
                &.at {
                    &::after {
                        position: absolute;
                        bottom: -10px;
                        left: 0;
                        content: '';
                        width: 100%;
                        height: 2px;
                        background: linear-gradient(270deg, rgba(113, 186, 188, 0.0001) 0%, #71BBBD 33.33%, #6DB5B7 66.67%, rgba(111, 185, 187, 0.0001) 100%);
                    }
                }
            }
        }
    }
    .p-content {
        width: 100%;
        height: 450px;
        // .item {
        //     width: 50%;
        //     font-size: $FontSize20;
        //     padding: 10px 0;
        //     .item-l {
        //         width: 20px;
        //         height: 20px;
        //         border-radius: 50%;
        //         margin-right: 10px;
        //     }
        //     .item-c {
        //         width: 80px;
        //     }
        // }
        .item{
            height: 140px;
            width: 200px;
            .item-r{
                display: flex;
                height: 100%;
                justify-content: space-between;
                .label{
                    font-size: $FontSize30;
                }
                .num{
                    font-size: $FontSize40;
                    color: $FontColor;
                }
            }
        }
    }
    .boxItem{
        width: 100%;
        height: 100%;
    }
}
.list{
    .num{
        @include ffamily-DS;
        font-size: $FontSize50;
    }
    .name{
        font-size: $FontSize36;
    }
}

.img{
    animation: breath_light 3s ease infinite;
}
</style>